import * as React from "react";
import { WrappedFieldProps } from "redux-form";
import FormGroupSelect from "./form_group_select";

interface IProps {
  type: string;
  required?: boolean;
  name: string;
  label: string;
  disabled?: boolean;
  require?: boolean;
  unit?: string;
  backgroundColor?: string;
  fontWeight?: string;
}

const FormGroupSelectConnectRf: React.FC<IProps & WrappedFieldProps> = (
  props
) => {
  const {
    type,
    required,
    name,
    label,
    meta,
    input,
    disabled,
    require,
    unit,
    children,
  } = props;
  const hasError = !!meta.error && !!meta.touched;

  return (
    <FormGroupSelect
      type={type}
      required={required}
      name={name}
      label={label}
      hasError={hasError}
      input={input}
      errorText={meta.error}
      disabled={disabled}
      require={require}
      unit={unit}
      children={children}
      backgroundColor={props.backgroundColor}
      fontWeight={props.fontWeight}
    />
  );
};

export default FormGroupSelectConnectRf;



// WEBPACK FOOTER //
// ./src/presentation/common/molecular/form_group/form_group_select_connect_rf.tsx